module.exports = __webpack_public_path__ + "img/2020-147_Stravenky-logoA-2025-04.cde3b9a1.png";